const resize = () => {
  window.scrollTo(0, 0);
  const whoFuckingDidThis: any = document.getElementsByClassName("content")[0];
  const handleResize = () => {
    if (window.innerWidth >= 1200) whoFuckingDidThis.style.padding = "50px 0 0";
    if (window.innerWidth < 1200) whoFuckingDidThis.style.padding = "75px 0 0";
  };
  handleResize();
  window.addEventListener("resize", handleResize);
  return () => {
    window.removeEventListener("resize", handleResize);
  };
};

export default resize;
